import {createSlice} from '@reduxjs/toolkit'
import {
    applyDataFiltersDI,
    applyDataFiltersPOS,
    applyDataFiltersTA,
    applyDataFiltersTC,
    applyDataFiltersTL,
    applyDataFiltersTP,
    acPayload
} from './strategicDashboard.action'
import {type IInitialStateProps} from './strategicDashboard.model'

const initialState: IInitialStateProps = {
    isLoading: false,
    error: null,
    branchActivity: {},
    MyAllotments: {},
    topCarriers: {},
    topOdPairs: [],
    myCarriers: {},
    myShipments: {},
    reportData: {},
    pointOfSalesData: {},
    topLanesData: {},
    topCommoditiesData: {},
    topProductsData: {},
    topAccountsData: {},
    domesticAndInternationalData: {},
    payloadValues: {}
}

const ACStrategicDashboardSlice = createSlice({
    name: 'Airline Carrier Strategic Dashboard',
    initialState,
    reducers: {
        resetState: () => initialState
    },
    extraReducers: (builder) =>
        builder
            .addCase(applyDataFiltersPOS.pending, (state) => {
                state.pointOfSalesData.isLoading = true
                state.pointOfSalesData.error = null
            })
            .addCase(applyDataFiltersPOS.fulfilled, (state, action: any) => {
                state.pointOfSalesData.isLoading = false
                state.pointOfSalesData.error = null
                state.pointOfSalesData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersPOS.rejected, (state, action: any) => {
                state.pointOfSalesData.isLoading = false
                state.pointOfSalesData.error = action.payload.error
                state.pointOfSalesData.data = {}
            })
            .addCase(applyDataFiltersTL.pending, (state) => {
                state.topLanesData.isLoading = true
                state.topLanesData.error = null
            })
            .addCase(applyDataFiltersTL.fulfilled, (state, action: any) => {
                state.topLanesData.isLoading = false
                state.topLanesData.error = null
                state.topLanesData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersTL.rejected, (state, action: any) => {
                state.topLanesData.isLoading = false
                state.topLanesData.error = action.payload.error
                state.topLanesData.data = {}
            })
            .addCase(applyDataFiltersTC.pending, (state) => {
                state.topCommoditiesData.isLoading = true
                state.topCommoditiesData.error = null
            })
            .addCase(applyDataFiltersTC.fulfilled, (state, action: any) => {
                state.topCommoditiesData.isLoading = false
                state.topCommoditiesData.error = null
                state.topCommoditiesData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersTC.rejected, (state, action: any) => {
                state.topCommoditiesData.isLoading = false
                state.topCommoditiesData.error = action.payload.error
                state.topCommoditiesData.data = {}
            })
            .addCase(applyDataFiltersTP.pending, (state) => {
                state.topProductsData.isLoading = true
                state.topProductsData.error = null
            })
            .addCase(applyDataFiltersTP.fulfilled, (state, action: any) => {
                state.topProductsData.isLoading = false
                state.topProductsData.error = null
                state.topProductsData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersTP.rejected, (state, action: any) => {
                state.topProductsData.isLoading = false
                state.topProductsData.error = action.payload.error
                state.topProductsData.data = {}
            })
            .addCase(applyDataFiltersTA.pending, (state) => {
                state.topAccountsData.isLoading = true
                state.topAccountsData.error = null
            })
            .addCase(applyDataFiltersTA.fulfilled, (state, action: any) => {
                state.topAccountsData.isLoading = false
                state.topAccountsData.error = null
                state.topAccountsData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersTA.rejected, (state, action: any) => {
                state.topAccountsData.isLoading = false
                state.topAccountsData.error = action.payload.error
                state.topAccountsData.data = {}
            })
            .addCase(applyDataFiltersDI.pending, (state) => {
                state.domesticAndInternationalData.isLoading = true
                state.domesticAndInternationalData.error = null
            })
            .addCase(applyDataFiltersDI.fulfilled, (state, action: any) => {
                state.domesticAndInternationalData.isLoading = false
                state.domesticAndInternationalData.error = null
                state.domesticAndInternationalData.data = action?.payload || {}
            })
            .addCase(applyDataFiltersDI.rejected, (state, action: any) => {
                state.domesticAndInternationalData.isLoading = false
                state.domesticAndInternationalData.error = action.payload.error
                state.domesticAndInternationalData.data = {}
            })
            .addCase(acPayload, (state, action) => {
                state.payloadValues = action.payload
            })
})

export const {resetState} = ACStrategicDashboardSlice.actions
export const {reducer: ACStrategicDashboardReducer} = ACStrategicDashboardSlice
